import { tokens } from '@arvoreeducacao/bonsai-ds'

export const READING_DATA_INFO_ITEMS = [
  {
    id: 1,
    title: 'Acima de 50%',
    text: 'A maior parte das páginas foi lida com uma velocidade adequada.',
    backgroundColor: tokens.colors.dark1,
    textColor: tokens.colors.dark5
  },
  {
    id: 2,
    title: 'Abaixo de 50%',
    text: 'A maior parte das páginas foi lida com uma velocidade acima e/ou abaixo do esperado, ou não foi lida.',
    backgroundColor: tokens.colors.dark1,
    textColor: tokens.colors.dark5
  }
]
